import axios from "axios";
import React from "react";
import {FallbackProps} from "react-error-boundary";
import {FormattedMessage} from "react-intl";
import "../styles/MapPageView.css";

export function ErrorMessage({error, resetErrorBoundary}: FallbackProps) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
        return (
            <div className="message">
                <h3>
                    <FormattedMessage id="ride_not_found" />
                </h3>
            </div>
        );
    }
    return (
        <div className="message">
            <div>
                <h3>
                    <FormattedMessage id="generic_error" />
                </h3>
                <p style={{fontSize: "12px"}}>Error: {error.message}</p>
                <button className="link-button" onClick={resetErrorBoundary}>
                    <FormattedMessage id="try_again" />
                </button>
            </div>
        </div>
    );
}
